import { render, staticRenderFns } from "./DescargoGralPage.vue?vue&type=template&id=de31cae4"
import script from "./DescargoGralPage.js?vue&type=script&lang=js&external"
export * from "./DescargoGralPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports